<script>
import { VList } from 'vuetify/lib'

export default {
  name: 'EMenuList',
  extends: VList,
  computed: {
    classes() {
      return {
        'e-menu-list': true,
        ...VList.options.computed.classes.call(this),
      }
    },
  },
}
</script>
